import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { fetchEntityHistory } from '../../services/activityService';
import styles from './ActivityHistoryModal.module.css';
import { FaTimes, FaHistory, FaUser, FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';

const ActivityHistoryModal = ({ isOpen, onRequestClose, entityType, entityId, entityName }) => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isOpen && entityId) {
            const loadHistory = async () => {
                setLoading(true);
                try {
                    const data = await fetchEntityHistory(entityType, entityId);
                    setActivities(data);
                } catch (error) {
                    console.error('Error fetching history:', error);
                } finally {
                    setLoading(false);
                }
            };
            loadHistory();
        }
    }, [isOpen, entityType, entityId]);

    const getActionText = (action) => {
        switch (action) {
            case 'CREATE': return 'Created';
            case 'UPDATE': return 'Updated';
            case 'DELETE': return 'Deleted';
            case 'MOVE': return 'Moved';
            case 'IMAGE_UPLOAD': return 'Image Added';
            case 'AI_UPDATE': return 'AI Processed';
            default: return action;
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
            contentLabel="Activity History"
        >
            <div className={styles.header}>
                <h2><FaHistory className={styles.titleIcon} /> History: {entityName}</h2>
                <button onClick={onRequestClose} className={styles.closeButton}><FaTimes /></button>
            </div>

            <div className={styles.content}>
                {loading ? (
                    <div className={styles.loading}>Loading activity logs...</div>
                ) : activities.length === 0 ? (
                    <div className={styles.noData}>No activity history found for this item.</div>
                ) : (
                    <div className={styles.tableWrapper}>
                        <table className={styles.activityTable}>
                            <thead>
                                <tr>
                                    <th><FaCalendarAlt /> Date & Time</th>
                                    <th><FaUser /> User</th>
                                    <th>Action</th>
                                    <th><FaInfoCircle /> Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity) => (
                                    <tr key={activity.id} className={styles.row}>
                                        <td className={styles.dateCol}>{formatDate(activity.timestamp)}</td>
                                        <td className={styles.userCol}>{activity.username}</td>
                                        <td className={styles.actionCol}>
                                            <span className={`${styles.actionBadge} ${styles[activity.action.toLowerCase()]}`}>
                                                {getActionText(activity.action)}
                                            </span>
                                        </td>
                                        <td className={styles.detailsCol}>{activity.details}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ActivityHistoryModal;
